import { observable, action, computed } from 'mobx';
import { isDebuggerStatement } from '@babel/types';

class ReportStore {
  @observable popularSlides = [];

  constructor(rootStore) {
    this.rootStore = rootStore;
  }

  @action loadData= (firebase) => {
    let slides = [];
    firebase.analytics().where("event", "==", "SLIDE_CHANGE")
        .orderBy('totalDuration', 'desc')
        .limit(5)
        .get()
        .then(snapshot=> {
            snapshot.forEach(doc => {
                const slide = doc.data();
                slides.push({
                  title: slide.title,
                  duration: slide.totalDuration,
                  documentId: slide.documentId,
                  slideNo: slide.slideNo,
                  meetingId: slide.meetingId
                });
            });
            this.popularSlides = slides;
        }, (err)=>{
            console.log('---raise an error here--'+err);
        });
  }

  @computed get slideList() {
    return Object.keys(this.popularSlides || {}).map(key => ({
      ...this.popularSlides[key]
    }));
  }

}

export default ReportStore;
